<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--signin" id="m_login">
	<div class="m-grid__item m-grid__item--order-tablet-and-mobile-2 m-login__aside">
		<div class="m-stack m-stack--hor m-stack--desktop">
			<div class="m-stack__item m-stack__item--fluid">
				<div class="m-login__wrapper">
					<div class="m-login__logo">
						<a href="#">
							<img src="./assets/app/media/img/logos/logo-login.png">
						</a>
					</div>
					<div class="m-login__signin">
						<div class="m-login__head">
							<h3 class="m-login__title">
								ArcAdmin User Verification
							</h3>
						</div>
						<div class="m-blockui">
							<span>
								Verifying user...
							</span>
							<span>
								<div class="m-loader m-loader--brand"></div>
							</span>
						</div>
						<div class="">
							<a [routerLink]="['/login']" class=""><span class="">Return to login page</span></a>
						</div>
						<swal #verifySuccess title="Verify User" text="Your account has successsfully been verified." type="success"></swal>
						<swal #verifyError title="Verify User Error" text="There has been an error verifying your account." type="error"></swal>

						<!--
						<form (ngSubmit)="f.form.valid && resetPass()" #f="ngForm" class="m-login__form m-form" action="">
							<swal #resetSuccess title="Reset Password" text="Your password has been successfully reset." type="success"></swal>
							<swal #resetError title="Reset Password Error" text="" type="error"></swal>
							<div class="form-group m-form__group">
								<input class="form-control m-input" type="password" placeholder="Password" name="password" [(ngModel)]="model.password" #password="ngModel">
							</div>
							<div class="form-group m-form__group">
								<input class="form-control m-input m-login__form-input--last" type="password" placeholder="Confirm Password" name="confirm" [(ngModel)]="model.verifyPassword" #confirm="ngModel">
							</div>
							<div class="m-login__form-action">
								<button [disabled]="loading" [ngClass]="{'m-loader m-loader--right m-loader--light': loading}" id="m_update_password_submit" class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air">
									Update
								</button>
								<button [disabled]="loading"  id="m_update_password_cancel" class="btn btn-outline-focus m-btn m-btn--pill m-btn--custom" (click)="cancel()">
									Cancel
								</button>
							</div>
						</form>
						-->
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1	m-login__content" style="background-image: url(./assets/app/media/img/bg/bg-login.jpg)">
		<div class="m-grid__item m-grid__item--middle">
			<h3 class="m-login__welcome">
				IllumAdmin
			</h3>
			<p class="m-login__msg">
				Safe, anytime, anywhere.
			</p>
		</div>
	</div>
</div>